import {Pipe, PipeTransform} from '@angular/core';
import {AgreementRepresentation} from '@aztrix/sdk';

import {isExpired} from '../../helpers/agreement-functions';

@Pipe({
  name: 'agreementIsExpired',
})
export class AgreementIsExpiredPipe implements PipeTransform {
  transform(agreement: AgreementRepresentation): boolean {
    return isExpired(agreement);
  }
}
